import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class EinvoiceSubmissionHistoryExportQueryCriteriaClass extends BaseCriteriaModel {
    
    hdr_guids?: Optional<string[]> = Optional.empty();
    line_irb_hdr_guids?: Optional<string[]> = Optional.empty();
    hdr_generic_doc_hdr_guids?: Optional<string[]> = Optional.empty();
    hdr_einvoice_buyer_entity_hdr_guids?: Optional<string[]> = Optional.empty();
    hdr_einvoice_delivery_entity_hdr_guids?: Optional<string[]> = Optional.empty();
    hdr_branch_guids?: Optional<string[]> = Optional.empty();
    
    // hdr level string filters
    hdr_supplier_names?: Optional<string[]> = Optional.empty();
    hdr_buyer_names?: Optional<string[]> = Optional.empty();
    hdr_supplier_tax_ids?: Optional<string[]> = Optional.empty();
    hdr_supplier_id_nos?: Optional<string[]> = Optional.empty();
    hdr_supplier_sales_service_tax_ids?: Optional<string[]> = Optional.empty();
    hdr_supplier_emails?: Optional<string[]> = Optional.empty();
    hdr_supplier_standard_indu_class_codes?: Optional<string[]> = Optional.empty();
    hdr_supplier_business_activity_descs?: Optional<string[]> = Optional.empty();
    hdr_buyer_tax_ids?: Optional<string[]> = Optional.empty();
    hdr_buyer_id_nos?: Optional<string[]> = Optional.empty();
    hdr_buyer_sales_service_tax_ids?: Optional<string[]> = Optional.empty();
    hdr_supplier_tourism_tax_ids?: Optional<string[]> = Optional.empty();
    hdr_buyer_emails?: Optional<string[]> = Optional.empty();
    hdr_supplier_addresses?: Optional<string[]> = Optional.empty();
    hdr_buyer_addresses?: Optional<string[]> = Optional.empty();
    hdr_supplier_contact_nos?: Optional<string[]> = Optional.empty();
    hdr_buyer_contact_nos?: Optional<string[]> = Optional.empty();
    hdr_einvoice_vers?: Optional<string[]> = Optional.empty();
    hdr_einvoice_types?: Optional<string[]> = Optional.empty();
    hdr_einvoice_code_nos?: Optional<string[]> = Optional.empty();
    hdr_original_einvoice_ref_nos?: Optional<string[]> = Optional.empty();
    hdr_supplier_digital_signatures?: Optional<string[]> = Optional.empty();
    hdr_invoice_currency_codes?: Optional<string[]> = Optional.empty();
    hdr_billing_frequencies?: Optional<string[]> = Optional.empty();
    hdr_irb_doc_unique_ref_nos?: Optional<string[]> = Optional.empty();
    hdr_submission_statuses?: Optional<string[]> = Optional.empty();
    hdr_posting_status?: Optional<string[]> = Optional.empty();
    hdr_generic_doc_hdr_server_doc_types?: Optional<string[]> = Optional.empty();
    hdr_generic_doc_hdr_server_doc_1s?: Optional<string[]> = Optional.empty();
    code_companies?: Optional<string[]> = Optional.empty();
    hdr_einvoice_document_statuses?: Optional<string[]> = Optional.empty();
    hdr_generic_doc_hdr_server_doc_2s?: Optional<string[]> = Optional.empty();
    hdr_generic_doc_hdr_server_doc_3s?: Optional<string[]> = Optional.empty();
    hdr_branch_codes?: Optional<string[]> = Optional.empty();
    
    // line level string filters
    line_classifications?: Optional<string[]> = Optional.empty();
    line_item_names?: Optional<string[]> = Optional.empty();
    line_tax_types?: Optional<string[]> = Optional.empty();
    line_tax_exemption_details?: Optional<string[]> = Optional.empty();
    line_uoms?: Optional<string[]> = Optional.empty();
    line_settlement_methods?: Optional<string[]> = Optional.empty();
    line_settlement_types?: Optional<string[]> = Optional.empty();
    line_payment_terms?: Optional<string[]> = Optional.empty();
    line_payment_reference_numbers?: Optional<string[]> = Optional.empty();
    line_bill_reference_numbers?: Optional<string[]> = Optional.empty();
    
    // hdr numeric filters
    hdr_currency_rate?: Optional<number> = Optional.empty();
    hdr_tax_exemption_amount?: Optional<number> = Optional.empty();
    hdr_sub_total?: Optional<number> = Optional.empty();
    hdr_total_exclude_tax?: Optional<number> = Optional.empty();
    hdr_total_include_tax?: Optional<number> = Optional.empty();
    
    // line numeric filters
    line_unit_price?: Optional<number> = Optional.empty();
    line_tax_rate?: Optional<number> = Optional.empty();
    line_tax_amount?: Optional<number> = Optional.empty();
    line_tax_exemption_amount?: Optional<number> = Optional.empty();
    line_qty?: Optional<number> = Optional.empty();
    line_discount_rate?: Optional<number> = Optional.empty();
    line_discount_amount?: Optional<number> = Optional.empty();
    line_payment_amount?: Optional<number> = Optional.empty();

    applyOrLogicToQueryEntity?: Optional<boolean> = Optional.empty();
    to_irb_running_nos?: Optional<string[]> = Optional.empty();
    doc_references?: Optional<string[]> = Optional.empty();
    
    // hdr date range filters
    hdr_einvoice_datetime_from?: Optional<string> = Optional.empty();
    hdr_einvoice_datetime_to?: Optional<string> = Optional.empty();
    hdr_validation_datetime_from?: Optional<string> = Optional.empty();
    hdr_validation_datetime_to?: Optional<string> = Optional.empty();
    hdr_created_date_from?: Optional<string> = Optional.empty();
    hdr_created_date_to?: Optional<string> = Optional.empty();
    hdr_updated_date_from?: Optional<string> = Optional.empty();
    hdr_updated_date_to?: Optional<string> = Optional.empty();
    hdr_actual_submission_date_from?: Optional<string> = Optional.empty();
    hdr_actual_submission_date_to?: Optional<string> = Optional.empty();
    hdr_einvoice_billing_period_start_from?: Optional<string> = Optional.empty();
    hdr_einvoice_billing_period_start_to?: Optional<string> = Optional.empty();
    hdr_einvoice_billing_period_end_from?: Optional<string> = Optional.empty();
    hdr_einvoice_billing_period_end_to?: Optional<string> = Optional.empty();
    
    // line date range filters
    line_payment_date_to?: Optional<string> = Optional.empty();
    line_payment_date_from?: Optional<string> = Optional.empty();
    line_created_date_from?: Optional<string> = Optional.empty();
    line_created_date_to?: Optional<string> = Optional.empty();
    line_updated_date_from?: Optional<string> = Optional.empty();
    line_updated_date_to?: Optional<string> = Optional.empty();

    date_txn_from?: Optional<string> = Optional.empty();
    date_txn_to?: Optional<string> = Optional.empty();

    client_doc_1s?: Optional<string[]> = Optional.empty();
    client_doc_2s?: Optional<string[]> = Optional.empty();
    client_doc_3s?: Optional<string[]> = Optional.empty();
    client_doc_4s?: Optional<string[]> = Optional.empty();
    client_doc_5s?: Optional<string[]> = Optional.empty();
    
}